import { useEffect, useState } from "react";
import api from "../lib/api";
import FreelancerCard from "../components/FreelancerCard";
import { FREELANCE_SPECIALIZATIONS } from "../data/specializations";

export default function FreelancersList() {
  const [list, setList] = useState([]);
  const [spec, setSpec] = useState("");
  const [q, setQ] = useState("");

  const load = async () => {
    const qs = new URLSearchParams();
    if (spec) qs.set("specialization", spec);
    if (q) qs.set("q", q);
    const { data } = await api.get(`/freelancers?${qs.toString()}`);
    setList(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [spec, q]);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-testid="freelancers-list">
      <span className="label-eyebrow text-muted-foreground">Find talent</span>
      <h1 className="mt-2 font-display text-3xl sm:text-4xl tracking-tighter">Freelancers</h1>

      <div className="mt-6 flex flex-wrap gap-2 items-center">
        <input className="input-base max-w-xs" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} data-testid="freelancer-search" />
        <select className="input-base max-w-xs" value={spec} onChange={e => setSpec(e.target.value)} data-testid="freelancer-spec">
          <option value="">All specializations</option>
          {FREELANCE_SPECIALIZATIONS.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.length === 0 ? <p className="text-sm text-muted-foreground">No freelancers yet.</p> : list.map(f => <FreelancerCard key={f.user_id} f={f} />)}
      </div>
    </div>
  );
}
